import { render, staticRenderFns } from "./SmTableDashboardProcessingStatus.vue?vue&type=template&id=b6c588c0&scoped=true&"
import script from "./SmTableDashboardProcessingStatus.vue?vue&type=script&lang=ts&"
export * from "./SmTableDashboardProcessingStatus.vue?vue&type=script&lang=ts&"
import style0 from "./SmTableDashboardProcessingStatus.vue?vue&type=style&index=0&id=b6c588c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c588c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
